import script from "./FieldInputAutocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./FieldInputAutocomplete.vue?vue&type=script&setup=true&lang=js"

import "./FieldInputAutocomplete.vue?vue&type=style&index=0&id=80f19556&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80f19556"]])

export default __exports__